'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _class2, _temp2, _class3, _temp3; /**
                                                      * Created by li on 2016/4/14.
                                                      */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftNavButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LeftNavButton, _Component);

  function LeftNavButton() {
    (0, _classCallCheck3.default)(this, LeftNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LeftNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(LeftNavButton, [{
    key: 'render',
    value: function render() {
      var styles = require('./ProductInfoFirstCarousel.scss');
      var className = styles.flexPrev;
      if (this.props.first) {
        className = className + ' ' + styles.flexFirst;
      }
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: className }));
    }
  }]);
  return LeftNavButton;
}(_react.Component), _class.propTypes = {
  first: _react.PropTypes.bool
}, _temp);
var RightNavButton = (_temp2 = _class2 = function (_Component2) {
  (0, _inherits3.default)(RightNavButton, _Component2);

  function RightNavButton() {
    (0, _classCallCheck3.default)(this, RightNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(RightNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(RightNavButton, [{
    key: 'render',
    value: function render() {
      var styles = require('./ProductInfoFirstCarousel.scss');
      var className = styles.flexNext;
      if (this.props.first) {
        className = className + ' ' + styles.flexFirst;
      }
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: className }));
    }
  }]);
  return RightNavButton;
}(_react.Component), _class2.propTypes = {
  first: _react.PropTypes.bool
}, _temp2);
var ProductInfoFirstCarousel = (_temp3 = _class3 = function (_Component3) {
  (0, _inherits3.default)(ProductInfoFirstCarousel, _Component3);

  function ProductInfoFirstCarousel() {
    (0, _classCallCheck3.default)(this, ProductInfoFirstCarousel);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ProductInfoFirstCarousel).apply(this, arguments));
  }

  (0, _createClass3.default)(ProductInfoFirstCarousel, [{
    key: 'render',
    value: function render() {
      var styles = require('./ProductInfoFirstCarousel.scss');
      var page = this.props.page;

      var dotClass = 'slick-dots ' + styles.dotsClass;
      if (page === 'Intro') {
        dotClass = 'slick-dots ' + styles.dotsIntroClass;
      }
      var settings = {
        dots: true,
        infinite: true,
        arrows: true,
        dotsClass: dotClass,
        fade: true,
        speed: 1500,
        autoplay: false,
        // autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
        prevArrow: _react2.default.createElement(LeftNavButton, this.props),
        nextArrow: _react2.default.createElement(RightNavButton, this.props)
      };
      var _props = this.props;
      var images = _props.images;
      var goeasyStyle = _props.goeasyStyle;

      var content = '';
      if (images instanceof Array) {
        if (images.length > 1) {
          (function () {
            var result = [];
            images.forEach(function (image, index) {
              if (image.img) {
                result.push(_react2.default.createElement('img', { key: index, alt: '', src: image.img }));
              }
            });
            content = _react2.default.createElement(
              _reactSlick2.default,
              (0, _extends3.default)({ className: styles.carousel, style: (0, _extends3.default)({}, goeasyStyle) }, settings),

              /*
               images.map((image, index)=> {
               if (image.img) {
               return <img key={index} alt="" src={image.img}/>;
               }
               }) */
              result
            );
          })();
        } else if (images.length === 1) {
          content = _react2.default.createElement('img', { className: styles.singleImg, alt: '', src: images[0].img });
        }
      }
      return content;
    }
  }]);
  return ProductInfoFirstCarousel;
}(_react.Component), _class3.propTypes = {
  images: _react.PropTypes.array.isRequired,
  goeasyStyle: _react.PropTypes.object,
  first: _react.PropTypes.bool,
  page: _react.PropTypes.string
}, _temp3);
exports.default = ProductInfoFirstCarousel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ProductInfoFirstCarousel/ProductInfoFirstCarousel.js
 ** module id = 604
 ** module chunks = 0
 **/